module.exports = __webpack_public_path__ + "img/logo-icon.7e75d98a.png";